<template>
  <base-carousel
    v-if="inAppCheck && componentIsActive && showBanner && showComponentInVMXOnly"
    v-bind="baseCarouselProps"
  >
    <div
      class="carousel__item"
      v-for="(item, idx) in carouselItems"
      :key="idx"
    >
      <link-box v-bind="itemLinkBoxProps(item)" />
    </div>
  </base-carousel>
</template>

<script>
import { mapGetters } from 'vuex'

import LinkBox from '../LinkBox/index.vue'
import utils from '../utilities'
import BaseCarousel from './BaseCarousel/index.vue'
import componentIsActiveMixins from '../mixins/componentIsActiveMixins'

export default {
  name: 'Carousel',
  components: { LinkBox, BaseCarousel },
  mixins: [
    componentIsActiveMixins.componentProps,
    componentIsActiveMixins.method,
  ],
  data() {
    return {
      showBanner: false,
      carouselItems: [],
    }
  },
  props: {
    /**
     * items to display in horizontal-list
     */
    items: {
      type: Array,
      required: true,
    },
    aspect: {
      type: String,
      default: null,
    },
    onlyInApp: {
      type: Boolean,
      default: false,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    autoplaySeconds: {
      type: Number,
      default: 5,
    },
    showNavigation: {
      type: Boolean,
      default: true,
    },
    randomOrder: {
      type: Boolean,
      default: true,
    },
    displayOnPage: {
      type: Array,
      default() {
        return []
      },
    },
    inApp: {
      type: Boolean,
      default: true,
    },
    onlyInVMX: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    itemLinkBoxProps(item) {
      const props = item
      props.aspect = this.aspect
      return props
    },
    receiveMessage(event) {
      if (event.detail.message === 'bannerControl') {
        if (this.displayOnPage.length > 0) {
          this.showBanner = !!this.displayOnPage.includes(event.detail.info)
        } else {
          this.showBanner = true
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      inVMX: 'instancesState/getInVMX',
      isAppContainer: 'instancesState/getIsAppContainer',
    }),
    inAppCheck() {
      if (this.isAppContainer) {
        return this.inApp
      }
      return !this.onlyInApp
    },
    baseCarouselProps() {
      return {
        aspect: this.aspect,
        autoplay: this.autoplay,
        autoplaySeconds: this.autoplaySeconds,
        showNavigation: this.showNavigation,
      }
    },
    showComponentInVMXOnly() {
      if (this.onlyInVMX && this.inVMX) return true
      if (this.onlyInVMX && !this.inVMX) return false
      return true
    },
  },
  created() {
    this.items.forEach((item) => {
      const isItemActive = this.checkIsComponentTimeActive(item)
      if (isItemActive) {
        this.carouselItems.push(item)
      }
    })

    if (this.randomOrder) {
      utils.shuffleArray(this.carouselItems)
    }
  },
  mounted() {
    window.addEventListener('bannerControl', this.receiveMessage)
    // TODO banner on certain pages only
    /*
    this.showBanner = !!this.displayOnPage.includes(this.$route.params.page)
    console.log(this.$route.params.page)
    */
    if (this.displayOnPage.length === 0) {
      this.showBanner = true
    }
  },
}
</script>
